import { RefObject } from 'react'
import Konva from 'konva'

export const useStageCursor = (stageRef: RefObject<Konva.Stage | null>) => {
  const setCursor = (cursor: string) => {
    const container = stageRef.current?.container()
    if (container) container.style.cursor = cursor
  }
  return { setCursor }
}
